export default {
  title: 'Acheter des e-cartes cadeaux',
  subtitle:
    'Dites-le avec une carte cadeau de {{companyName}}. Parfaite pour les anniversaires, un remerciement ou juste pour faire plaisir – utilisable librement pour de la nourriture et des boissons.',
  header: {
    title: 'Carte cadeau',
    subtitle: 'Offrez de la joie',
  },
  buttons: {
    buy_now: 'Acheter',
  },
};
